<template>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <p class="title text-xs-center" style="margin-top: 10px;">Delete Click User Info</p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="startDateTime"
            :rules="[v => !!v || 'Pleae provide in YYYY-MM-DD HH:MM:SS formate.']"
            label="Start Date Time"
            required
          ></v-text-field>

          <v-text-field
            v-model="endDateTime"
            :rules="[v => !!v || 'Pleae provide in YYYY-MM-DD HH:MM:SS formate.']"
            label="Start Date Time"
            required
          ></v-text-field>

          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          
          <div class="text-xs-center">
          <v-btn :disabled="loading" @click="clear">clear</v-btn>

          <v-btn
            color="primary"
            :disabled="!valid || loading"
            @click="submit"
          >
            submit
          </v-btn>
          </div>
        </v-form>
      </v-flex>

      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Do You Want To Delete Click User Info ?</v-card-title>
          <v-card-text> Total Click User Info : {{totalClicks}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" @click.native="deleteCancel"> No </v-btn>
            <v-btn :disabled="loading || totalClicks == 0" color="primary" @click.native="deleteClicks"> Yes </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
</template>

<script>
import axios from 'axios'
import { SERVER_URL } from '@/constant.js'

export default {
  data () {
    return {
      valid: true,
      startDateTime: '',
      endDateTime: '',
      loading: false,
      dialog: false,
      totalClicks: 0
    }
  },
  methods: {
    clear () {
      this.$refs.form.reset()
    },
    submit () {
      
      if (isNaN(new Date(this.startDateTime).getTime()) || 
        isNaN(new Date(this.endDateTime).getTime())
      ) {
        var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Please end date in 2018-09-05 23:59:59 fomate.'})
        document.dispatchEvent(showSnackbarEvent);
      } else {
        this.loading = true;
        axios.get(`${SERVER_URL}/network/clickinfo/${new Date(this.startDateTime).getTime()}/${new Date(this.endDateTime).getTime()}`)
        .then(res => {
          this.totalClicks = res.data;
          this.loading = false;
          this.dialog = true;
        })
      }
    },
    deleteCancel () {
      this.$refs.form.reset()
      this.dialog = false;
    },
    deleteClicks () {
      if (isNaN(new Date(this.startDateTime).getTime()) || 
        isNaN(new Date(this.endDateTime).getTime())
      ) {
        var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Please end date in 2018-09-05 23:59:59 fomate.'})
        document.dispatchEvent(showSnackbarEvent);
        this.loading = false;
      } else {
        this.loading = true;
        axios.delete(`${SERVER_URL}/network/clickinfo/${new Date(this.startDateTime).getTime()}/${new Date(this.endDateTime).getTime()}`)
        .then(res => {
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: `Total ${res.data} click user info deleted successfully.`})
          document.dispatchEvent(showSnackbarEvent);
          this.$refs.form.reset()
          this.dialog = false;
          this.loading = false;
        })
      }
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/delete/DeleteClickInfo.vue